export default __webpack_public_path__ + "media/images/check-faded-purple-17c711bc.svg";